export default "__VITE_ASSET__ChzPEeg8__"